import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["amount"];
  static values = { platformPercent: Number };

  connect() {
    console.log("campaign-cause connected...");
  }

  updateInfoTextAmount(event) {
    const hostAmount = 100 - this.platformPercentValue;
    const causePercent = parseInt(event.currentTarget.value, 10) || 0;
    const causeAmount = Math.round((hostAmount / 100.0) * causePercent);
    this.amountTarget.textContent = `${causeAmount}p`;
  }
}
